import BuyCard from "../../../common/buy-card";
import ratingImg from "../../../../assets/img/rating.png";
import ratingImgWebp from "../../../../assets/img/rating.webp";
import firstProductImg from "../../../../assets/img/product-gg-2.png";
import firstProductImgWebp from "../../../../assets/img/product-gg-2.webp";
import secondProductImg from "../../../../assets/img/product-gg-6.png";
import secondProductImgWebp from "../../../../assets/img/product-gg-6.webp";
import thirdProductImg from "../../../../assets/img/product-gg-3.png";
import thirdProductImgWebp from "../../../../assets/img/product-gg-3.webp";

type Props = {
    isShown: boolean,
    showExtraLinks: boolean
};

const BuyNg = ({
    isShown,
    showExtraLinks
}: Props) => {
    return (
        <section id="buy" className={`${isShown ? '' : 'd-none'}`}>
            <div className="container-fluid text-center pt-3 pb-3">
                <div className="row justify-content-center align-items-center">
                    <div className="col-lg-3 col-11 mb-lg-1 mb-3">
                        <BuyCard
                            title="Try Two"
                            subtitle="2 bottles, 60 days supply"
                            imgSrc={firstProductImg}
                            imgSrcWebp={firstProductImgWebp}
                            bottlePrice={69}
                            savings={220}
                            hasGift={false}
                            total={358}
                            totalWithDiscount={138}
                            isFreeShipping={false}
                            buyLink="https://buygoods.com/secure/checkout.html?account_id=11273&product_codename=glu1&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9nbHVjb2dlbi11LTY="
                            gtmLabel="Buy 2 gg"
                            gtmProduct="glu1f"
                            showBorder={false}
                        />
                    </div>
                    <div className="col-lg-3 col-11 mb-lg-1 mb-3">
                        <BuyCard
                            title="Most Popular"
                            subtitle="3 bottles, 90 days supply"
                            imgSrc={thirdProductImg}
                            imgSrcWebp={thirdProductImgWebp}
                            bottlePrice={59}
                            savings={360}
                            hasGift={true}
                            total={537}
                            totalWithDiscount={177}
                            isFreeShipping={true}
                            buyLink="https://buygoods.com/secure/checkout.html?account_id=11273&product_codename=glu3&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9nbHVjb2dlbi11LTY="
                            gtmLabel="Buy 3 gg"
                            gtmProduct="glu3f"
                            showBorder={true}
                        />
                    </div>
                    <div className="col-lg-3 col-11 mb-lg-1 mb-3">
                        <BuyCard
                            title="Best Value"
                            subtitle="6 bottles, 180 days supply"
                            imgSrc={secondProductImg}
                            imgSrcWebp={secondProductImgWebp}
                            bottlePrice={49}
                            savings={780}
                            hasGift={true}
                            total={1074}
                            totalWithDiscount={294}
                            isFreeShipping={true}
                            buyLink="https://buygoods.com/secure/checkout.html?account_id=11273&product_codename=glu6&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9nbHVjb2dlbi11LTY="
                            gtmLabel="Buy 6 gg"
                            gtmProduct="glu6f"
                            showBorder={false}
                        />
                    </div>
                </div>
                <div className="row justify-content-center align-items-center mt-2">
                    <div className="col-11">
                        <span className="small me-2">Our customers say <b>4.98/5</b></span>
                        <picture>
                            <source srcSet={ratingImgWebp} type="image/webp" />
                            <img className="img-fluid gg-buy-img-rating mb-1" alt="rating" src={ratingImg} loading="lazy" />
                        </picture>
                        <span className="small ms-2"> Based on 2000+ reviews</span>
                    </div>
                </div>
                {showExtraLinks &&
                    <>
                        <div className="row justify-content-center align-baseline mt-4">
                            <div className="col-11">
                                <a href="#testimonials" className="text-black small pe-2 gtm-nav-btn" data-gtm-label="gg - Buy Section - View Testimonials Link">View Reviews</a>
                                |
                                <a href="#faq" className="text-black small ps-2 gtm-nav-btn" data-gtm-label="gg - Buy Section - View FAQ Link">View FAQ's</a>
                            </div>
                        </div>
                    </>
                }
            </div>
        </section>
    )
};

export default BuyNg;